import styled from 'styled-components'

export const StylesRepeatOccurrenceArrow = styled.div`
  width: 24px;
  height: 48px;
  display: flex;
  flex-direction: column;
  margin-left: 9px;
  cursor: pointer;

  .arrow-down {
    rotate: 180deg;
  }
`
